import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { ClipLoader, BeatLoader } from "react-spinners";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import image1 from "../assets/Images/Ellipse 21.png";
import image4 from "../assets/Images/Ellipse 24.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import { NotificationContext } from "../contexts/NotificationContext";
import useFriendRequestHooks from "../hooks/frienRequestHooks";
import { FaBell } from "react-icons/fa";

const NotificationPop = ({
  show,
  target,
  setShow,
  liveNotification,
  setLiveNotification,
}) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { setUnreadCount, fetchUnreadCount } = useContext(NotificationContext);
  const { getFriends, acceptFriendRequest, rejectFriendRequest } =
    useFriendRequestHooks();
  const [processingRequest, setProcessingRequest] = useState({});
  const url = process.env.REACT_APP_LARAVEL_DOMAIN_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [message, setMessage] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [brokenImages, setBrokenImages] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (user) fetchNotifications(isRead, 1);
  }, [user, isRead]);

  const fetchNotifications = async (isRead = false, page = 1) => {
    if (page === 1) {
      setLoadingNotifications(true);
    } else {
      setLoadingMore(true);
    }
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${apiUrl}/user/notification/get?is_read=${isRead ? 1 : 0}&page=${page}&per_page=10`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const data = await res.json();
      if (data && data.status && Array.isArray(data.data)) {
        if (page === 1) {
          setNotifications(data.data);
        } else {
          setNotifications((prev) => [...prev, ...data.data]);
        }
        setCurrentPage(data.meta?.current_page ?? page);
        setHasMore((data.meta?.current_page ?? page) < (data.meta?.last_page ?? 1));
      } else {
        if (page === 1) setNotifications([]);
        setHasMore(false);
      }
    } catch (e) {
      if (page === 1) setNotifications([]);
      setHasMore(false);
    }
    setLoadingNotifications(false);
    setLoadingMore(false);
  };

  const handleScroll = useCallback(() => {
    const el = bodyRef.current;
    if (!el || loadingMore || !hasMore) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
      fetchNotifications(isRead, currentPage + 1);
    }
  }, [loadingMore, hasMore, isRead, currentPage]);

  useEffect(() => {
    if (liveNotification) {
      console.log("Notifications from popup:", liveNotification);
    }
  }, [liveNotification]);


  const handleAccept = async (reqId) => {
    setProcessingRequest((prev) => ({ ...prev, [reqId]: "accept" }));
    try {
      await acceptFriendRequest(reqId);
      setIncomingRequests((prev) => prev.filter((r) => r.id !== reqId));
    } catch (e) {
      // Optionally show error
    }
    setProcessingRequest((prev) => ({ ...prev, [reqId]: null }));
  };

  const handleDecline = async (reqId) => {
    setProcessingRequest((prev) => ({ ...prev, [reqId]: "decline" }));
    try {
      await rejectFriendRequest(reqId);
      setIncomingRequests((prev) => prev.filter((r) => r.id !== reqId));
    } catch (e) {
      // Optionally show error
    }
    setProcessingRequest((prev) => ({ ...prev, [reqId]: null }));
  };
  const [incomingRequests, setIncomingRequests] = useState([]);

  // useEffect(() => {
  //   async function fetchIncoming() {
  //     try {
  //       const res = await getFriends("incoming");
  //       if (Array.isArray(res)) {
  //         setIncomingRequests(res);
  //       } else if (res && res.data) {
  //         setIncomingRequests(res.data);
  //       } else {
  //         setIncomingRequests([]);
  //       }
  //     } catch (e) {
  //       setIncomingRequests([]);
  //     }
  //   }
  //   fetchIncoming();
  // }, [getFriends]);
  // Function to handle mark as read
  const handleMarkAsRead = async (notifId) => {
    try {
      const token = localStorage.getItem("token");
      await fetch(`${apiUrl}/user/notification/mark-read/${notifId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      setNotifications((prev) =>
        prev.map((n) => (n.id === notifId ? { ...n, is_read: true } : n))
      );
      // Immediately decrement, then sync with server
      setUnreadCount((prev) => Math.max(0, prev - 1));
      fetchUnreadCount();
    } catch (e) {
      // Optionally show error
    }
  };

  const handleNavigation = (path) => {
    setShow(false); //close the popup first
    navigate(path); //then go to new page
  };

  // Normalize/merge JSON payload from notif.data (if present) into an object
  const parseNotif = (item) => {
    if (!item) return {};
    let n = { ...item };
    if (n.data) {
      try {
        const parsed = typeof n.data === "string" ? JSON.parse(n.data) : n.data;
        n = { ...n, ...parsed };
      } catch (err) {
        // ignore JSON parse errors
      }
    }
    return n;
  };

  // Handle notification click: friend_request should open personal-information with personId=senderId
  const handleNotificationClick = (item) => {
    const n = parseNotif(item);
    console.log(n, "notificationclick");

    setShow(false);
    setLiveNotification && setLiveNotification(null);

    // Helper to get sender/group id
    const resolveSenderId = (notif) =>
      notif.sender_id ||
      notif.senderId ||
      (notif.sender && (notif.sender.id || notif.sender_id)) ||
      notif.sender?.id;

    if (n.type === "group_event") {
      console.log(n, "group post notification click");
      const groupId = resolveSenderId(n);
      if (n.link) {
        try {
          // support relative and absolute URLs; if same origin use react-router navigate so state is preserved
          const urlObj = new URL(n.link, window.location.origin);
          const isSameOrigin = urlObj.origin === window.location.origin;
          const path = `${urlObj.pathname || ''}${urlObj.search || ''}${urlObj.hash || ''}`;
          if (isSameOrigin) {
            navigate(path, { state: { groupId } });
          } else {
            // external URL -> full redirect, append groupId as query param
            const sep = n.link.includes('?') ? '&' : '?';
            window.location.href = `${n.link}${sep}groupId=${encodeURIComponent(groupId)}`;
          }
        } catch (err) {
          // fallback: navigate as-is with state
          navigate(n.link, { state: { groupId } });
        }
      } else {
        // no link provided -> navigate to a reasonable default route
        navigate(`/groups/${groupId}`, { state: { groupId } });
      }
      return;
    }

    // Special handling: friend request
    if (n.type === "friend_request") {
      const senderId = resolveSenderId(n);
      navigate("/personal-information", { state: { personId: senderId }, replace: true });
      return;
    }

    // // Special handling: crew response — navigate to crew's profile
    // if (n.type === "crew_response" && n.sender_id) {
    //   navigate("/personal-information", { state: { personId: n.crew_id } });
    //   return;
    // }

      if (n.type === "crew_response" || n.type === "crew_application" || n.type === "crew_assignment") {
      const senderId = resolveSenderId(n);
      console.log('--- Notification Click ---', { type: n.type, senderId, notif: n });
      navigate("/personal-information", { state: { personId: senderId }, replace: true });
      return;
    }

    // Generic case: handle absolute frontend URLs (convert to pathname) and external URLs
    if (n.link) {
      try {
        const urlObj = new URL(n.link, window.location.origin);
        const isSameOrigin = urlObj.origin === window.location.origin;
        const path = `${urlObj.pathname || ''}${urlObj.search || ''}${urlObj.hash || ''}`;
        if (isSameOrigin) {
          navigate(path);
        } else {
          window.location.href = n.link;
        }
      } catch (err) {
        // fallback for invalid URL constructor input
        if (/^https?:\/\//.test(n.link)) {
          window.location.href = n.link;
        } else {
          navigate(n.link);
        }
      }
    }
  };


  // console.log(user, "alluserdetailsskipperRole");

  // const deliveryId = user?.skipper_deliveries.map(
  //   (item) => item?.delivery_request_id
  // );

  // console.log(deliveryId, "alluserdetailsskipperRole");

  // const encodedId = btoa(deliveryId);

  return (
    <>
      <Overlay
        show={show}
        target={target}
        placement="bottom"
        // container={ref}
        containerPadding={20}
        rootClose={true}
        onHide={() => setShow(false)}
      >
        <Popover
          id="popover-contained"
          style={{
            minWidth: 350,
            maxHeight: 500,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Popover.Header
            as="h3"
            style={{
              backgroundColor: "#fff",
              flexShrink: 0,
              zIndex: 2,
            }}
          >
            <div className=" d-flex justify-content-between">
              <p className="text-blue fs-6">Notification </p>

              <div className="form-check form-switch">
                <input
                  className="form-check-input custom-toggle"
                  type="checkbox"
                  name="groupNotification"
                  //checked={formik.values.groupNotification}
                  style={{ fontSize: 17 }}
                  onChange={(e) => {
                    setIsRead(e.target.checked)
                    setMessage(e.target.checked)
                    setCurrentPage(1);
                    setHasMore(false);
                    fetchNotifications(e.target.checked, 1);
                  }}
                />
                <label className="form-check-label" htmlFor="groupNotification">
                  {message ? "Read" : "Unread"}
                </label>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setShow(false)}
                style={{ fontSize: "0.8rem" }}
              />
            </div>


          </Popover.Header>
          <Popover.Body ref={bodyRef} onScroll={handleScroll} style={{ overflowY: "auto", flex: 1 }}>
            {liveNotification && (
              <div className="row pt-3">
                <div className="col-lg-9">
                  <div className="d-flex">
                    <img src={image1} height={40} />
                    <div>
                      <p className="ps-1 fw-bold">
                        {liveNotification.title || "Notification"}
                      </p>
                      <p className="notification_description fs-12 ps-1 fw-semibold text-break">
                        {typeof liveNotification === "object"
                          ? liveNotification.message
                          : liveNotification}
                      </p>
                      {(liveNotification.link || liveNotification.type === "friend_request" || liveNotification.type === "crew_assignment" || liveNotification.type === "crew_response" || liveNotification.type === "crew_application") && (
                        <button
                          className="btn btn-blue ms-1 mt-2"
                          style={{ padding: "1px 8px" }}
                          onClick={() => handleNotificationClick(liveNotification)}
                        >
                          View Details
                        </button>
                      )}

                      <button
                        className="btn btn-default ms-2 mt-2"
                        style={{ padding: "1px 8px" }}
                        onClick={() => setLiveNotification(null)}
                      >
                        X
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {user?.role === 3 &&
              user?.skipper_deliveries
                ?.filter((delivery) => delivery.status === "booked")
                .map((delivery) => {
                  const encodedId = btoa(
                    delivery.delivery_request_id.toString()
                  );

                  return (
                    <div className="row pt-3" key={delivery.id}>
                      <div className="col-lg-9">
                        <div className="d-flex">
                          {delivery?.boat_owner_profile_picture && !brokenImages[`delivery_${delivery.id}`] ? (
                            <img src={`${url}/${delivery.boat_owner_profile_picture}`} height={40} alt="Notification"
                              style={{
                                width: 40,
                                height: 40,
                                objectFit: "cover",
                                borderRadius: "50%",
                                background: "#eaeaea",
                                display: "block",
                                cursor: "pointer",
                              }}
                              onError={() => setBrokenImages((prev) => ({ ...prev, [`delivery_${delivery.id}`]: true }))}
                            />
                          ) : (
                            <FaBell size={40} className="text-muted" />
                          )}
                          <div>
                            <p className="ps-1 fw-bold">
                              Selected for Delivery Request
                            </p>
                            <p className="notification_description fs-12 ps-1 fw-semibold">
                              Congratulations! You have been selected for a
                              delivery request.
                            </p>
                            <button
                              className="btn btn-blue ms-1 mt-2"
                              style={{ padding: "1px 8px" }}
                              onClick={() =>
                                navigate(
                                  `/delivery-verification-check-in/${encodedId}`
                                )
                              }
                            >
                              More Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            {/* Render notifications from API */}
            {loadingNotifications ? (
              <div className="row pt-3">
                <div className="col-lg-12 text-center">
                  <ClipLoader color="#0a425c" size={32} />
                </div>
              </div>
            ) : notifications.length > 0 ? (
              notifications.map((notif) => (
                <div className="row pt-3 align-items-start" key={notif.id}>
                  <div className="col-12 col-lg-9 mb-2 mb-lg-0">
                    <div className="d-flex flex-column flex-sm-row align-items-start">
                      {notif.sender_profile && !brokenImages[notif.id] ? (
                        <img
                          src={`${url}/${notif.sender_profile}`}
                          height={40}
                          className="me-sm-2 mb-2 mb-sm-0"
                          style={{ width: 40, objectFit: "cover", borderRadius: "4px" }}
                          alt="notification"
                          onError={() => setBrokenImages((prev) => ({ ...prev, [notif.id]: true }))}
                        />
                      ) : (
                        <FaBell size={40} className="me-sm-2 mb-2 mb-sm-0 text-muted" />
                      )}
                      <div>
                        <p className="ps-sm-1 fw-bold mb-1">
                          {notif.title || "Notification"}
                        </p>
                        <p className="notification_description fs-12 ps-sm-1 fw-semibold mb-2 text-break">
                          {notif.message}
                        </p>

                        <div className="d-flex justify-content-between align-items-center mt-3 gap-3"
                          style={{ width: "124%" }}>
                          {(notif.link || notif.type === "friend_request" || notif.type === "crew_assignment" || notif.type === "crew_response" || notif.type === "crew_application") && (
                            <button
                              className="btn btn-blue w-100"
                              style={{ padding: "1px 8px" }}
                              onClick={() => handleNotificationClick(notif)}
                            >
                              View Details
                            </button>
                          )}
                          {!notif.is_read && (
                            <button
                              className="btn btn-sm btn-outline-success w-100"
                              style={{ padding: "1px 8px" }}
                              onClick={() => handleMarkAsRead(notif.id)}
                            >
                              Mark as Read
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-3 text-lg-end">
                    <p className="text-blue cursor-pointer fs-12 fw-bold mb-0">
                      {notif.hour_ago}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="row pt-3">
                <div className="col-lg-12 text-center text-muted">
                  No notifications found.
                </div>
              </div>
            )}
            {loadingMore && (
              <div className="row pt-3">
                <div className="col-12 text-center">
                  <BeatLoader color="#0a425c" size={10} />
                </div>
              </div>
            )}
            <>
              {incomingRequests &&
                incomingRequests.length > 0 &&
                incomingRequests.map((req, idx) => (
                  <div className="row pt-3" key={req.id || idx}>
                    <div className="col-lg-9">
                      <div className="d-flex">
                        {(req.sender_profile || (req.sender && req.sender.profile_picture)) ? (
                          <img
                            src={
                              (req.sender_profile || req.sender.profile_picture).startsWith("http")
                                ? (req.sender_profile || req.sender.profile_picture)
                                : `${url}/${req.sender_profile || req.sender.profile_picture}`
                            }
                            height={40}
                            width={40}
                            alt="profile"
                            style={{ borderRadius: "50%", objectFit: "cover" }}
                          />
                        ) : (
                          <FaBell size={40} className="text-muted" />
                        )}
                        <div>
                          <p className="ps-1 fw-bold">
                            {req.sender?.fname || "User"}{" "}
                            {req.sender?.lname || ""} wants to connect with you
                          </p>
                          <button
                            className="btn btn-blue ms-2 mt-1"
                            style={{ padding: "1px 8px" }}
                            onClick={() => handleAccept(req.id)}
                            disabled={processingRequest[req.id] === "accept"}
                          >
                            {processingRequest[req.id] === "accept"
                              ? "Processing..."
                              : "Accept"}
                          </button>
                          <button
                            className="btn btn-default ms-2 mt-1"
                            style={{ padding: "1px 8px" }}
                            onClick={() => handleDecline(req.id)}
                            disabled={processingRequest[req.id] === "decline"}
                          >
                            {processingRequest[req.id] === "decline"
                              ? "Processing..."
                              : "Decline"}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <p className="text-blue cursor-pointer fs-12 fw-bold text-end">
                        {req.created_at
                          ? new Date(req.created_at).toLocaleDateString()
                          : ""}
                      </p>
                    </div>
                  </div>
                ))}
            </>
            {/* {user.role === 3 ? null : (
              <>
                <div className="row pt-3">
                  <div className="col-lg-9">
                    <div className="d-flex">
                      <img src={image4} height={40} />
                      <div>
                        <p className="ps-1 pt-2 fw-bold">
                          Aline like your post
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <p className="text-blue cursor-pointer fs-12 fw-bold text-end pt-2">
                      3 Hour
                    </p>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-lg-9">
                    <h4 className="fs-14 fw-normal text-secondary fw-bold">
                      Yesterday
                    </h4>
                    <p className="text-blue fs-12   ">
                      Gold plan successfully subscription
                    </p>
                  </div>
                  <div className="col-lg-3">
                    <p className="text-blue cursor-pointer fs-12 fw-bold text-end">
                      View all
                    </p>
                    <p className="text-blue cursor-pointer fs-12 fw-bold text-end">
                      Yesterday
                    </p>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-lg-9">
                    <p className="text-blue fs-12   ">
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    </p>
                  </div>
                  <div className="col-lg-3">
                    <p className="text-blue cursor-pointer fs-12 fw-bold text-end">
                      Yesterday
                    </p>
                  </div>
                </div>
              </>
            )} */}
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};

export default NotificationPop;